import styled from "styled-components"

export const ShipperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 800px;
  position: relative;
  z-index: 1;
  /* :before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.9) 0%,
        rgba(0, 0, 0, 0.4) 100%
      ),
      linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, transparent 100%);
    z-index: 2;
  } */
`;

export const ShipperBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const ShipperImage = styled.img`
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;

`

export const ShipperContent = styled.div`
  max-width: 800px;
  z-index: 3;
  padding: 45px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  top: -100px;
  position: relative;

;

`;

export const ShipperH1 = styled.h1`
color: #fff;
  font-size: clamp(1rem, 2rem, 5rem);
  text-align: center;
  font-family: "Oxygen";
  line-height: 1.2;
  max-width: 500px;

`;

export const ShipperFormWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: center;
padding: 1rem;
& h3 {
  text-align: center;
  font-size: 2rem;
  color: #141e61;
}
`